import { Component, OnInit, Inject, ChangeDetectionStrategy } from '@angular/core';
import { UntypedFormGroup, UntypedFormBuilder } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { buildWorkCenterForm } from './work-center-form-builder';
import { WorkCenterDto } from '@app/generated/model';
import { WorkCenterService } from '@app/core/services/work-center.service';

@Component({
  selector: 'app-add-work-center',
  templateUrl: './add-work-center.component.html',
  styleUrls: ['./add-work-center.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class AddWorkCenterComponent implements OnInit {
  form: UntypedFormGroup;
  siteId: string;

  constructor(
    formBuilder: UntypedFormBuilder,
    private dialogRef: MatDialogRef<AddWorkCenterComponent>,
    private workCenterService: WorkCenterService,
    @Inject(MAT_DIALOG_DATA) data,
  ) {
    this.form = buildWorkCenterForm(formBuilder);
    this.siteId = data.siteId;
  }

  ngOnInit(): void {}

  onAdd(): void {
    if (!this.form.valid) {
      return;
    }
    const workCenter = this.form.getRawValue() as WorkCenterDto;
    this.workCenterService.addWorkCenter(this.siteId, workCenter).subscribe({
      next: () => this.dialogRef.close(true),
      error: (err) => console.error('Error adding work center:', err),
    });
  }

  onCancel(): void {
    this.dialogRef.close();
  }
}
